import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/loading-icon.png'


const _hoisted_1 = { class: "loading" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-img-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "loading-logo"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "載入中... 請稍等")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}